import { Tabs } from 'antd';
import React from 'react';
import TMSNakshatramManagement from './tms-nakshatram-management';
import TmsNakshatramCalendar from './tms-nakshatram-calendar';
import { withRouter } from '../../utils/tms-with-router/tms-with-router';

const TmsNakshatram = () => {
  return (
    <Tabs defaultActiveKey='1'>
      <Tabs.TabPane tab='Nakshatrams' key='1'>
        <TMSNakshatramManagement />
      </Tabs.TabPane>
      <Tabs.TabPane tab='Calendar' key='2'>
        <TmsNakshatramCalendar />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default withRouter(TmsNakshatram);
